import {
    css, Theme,
} from '@emotion/react'
import common from 'shared/styles'

import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        contextContainer: css`
            padding-left: 40px;
            padding-right: 40px;
            padding-top: 35px;
        `,
        actions: css`
            ${common.flexJustityAlignCenter};
            padding: 0;
        `,
        button: css`
            width: ${theme.custom?.button?.width} !important;
            margin: 40px 25px 40px 25px;
            ${custom.button};
        `,
    }
}

export default styles
